/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MailArrowInIcon16Light } from './MailArrowInIcon16Light';
import { MailArrowInIcon16Regular } from './MailArrowInIcon16Regular';
import { MailArrowInIcon16Solid } from './MailArrowInIcon16Solid';
import { MailArrowInIcon20Light } from './MailArrowInIcon20Light';
import { MailArrowInIcon20Regular } from './MailArrowInIcon20Regular';
import { MailArrowInIcon20Solid } from './MailArrowInIcon20Solid';
import { MailArrowInIcon24Regular } from './MailArrowInIcon24Regular';
import { MailArrowInIcon24Solid } from './MailArrowInIcon24Solid';
import { MailArrowInIcon32Regular } from './MailArrowInIcon32Regular';
import { MailArrowInIcon64Regular } from './MailArrowInIcon64Regular';
var sizes = {
    16: {
        light: MailArrowInIcon16Light,
        regular: MailArrowInIcon16Regular,
        solid: MailArrowInIcon16Solid,
    },
    20: {
        light: MailArrowInIcon20Light,
        regular: MailArrowInIcon20Regular,
        solid: MailArrowInIcon20Solid,
    },
    24: {
        regular: MailArrowInIcon24Regular,
        solid: MailArrowInIcon24Solid,
    },
    32: {
        regular: MailArrowInIcon32Regular,
    },
    64: {
        regular: MailArrowInIcon64Regular,
    },
};
export var MailArrowInIcon = forwardRef('MailArrowInIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
